<span (click)="closeMessage()" class="material-icons-outlined mi-close cancel-button">
  close
</span>
<ng-container *ngIf="customText; else defaultText">
  <!-- Angular's [innerHTML] binding automatically sanitizes HTML via DomSanitizer
       (strips <script>, event attributes, javascript: URLs, etc.) -->
  <div [innerHTML]="customText" style="padding: 0.5rem; padding-right: 1rem;"></div>
</ng-container>
<ng-template #defaultText>
  <p>
    Danke für das Feedback.
    Für persönlichen Kontakt zu einem/einer menschlichen Kolleg:in bitte die E-Mail-Adresse angeben.
  </p>
</ng-template>
<div *ngIf="showEmail" style="display: flex; flex-direction: row; padding: 0 1rem 0 0.5rem;">
  <input type="email" name="email" [(ngModel)]="email" placeholder="Deine E-Mail-Adresse"
    [ngClass]="{ 'invalid-email': !isEmailValid && touched }" (focus)="touched = true" />
  <button class="send-button" (click)="sendEmailData()" [disabled]="!isEmailValid">Send</button>
</div>
